export default "__VITE_ASSET__Cot4VAjw__"